import React, { useState, useMemo } from 'react';
import { Icons } from 'components/Icons';
import DocumentationLayout from 'components/documentation/DocumentationLayout';
import documentationContent from 'components/documentation/documentationContent.json';

const TechnicalDocumentation = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Documentation sections data - loaded from JSON (single source of truth)
  const docSections = useMemo(() => {
    // Map icon strings to Icons components
    const iconMap = {
      'sparkles': Icons.Sparkles,
      'settings': Icons.Settings,
      'info': Icons.Info,
      'document': Icons.Document
    };
    
    return documentationContent.sections.map(section => ({
      ...section,
      icon: iconMap[section.icon] || Icons.Document
    }));
  }, []);

  return (
    <DocumentationLayout
      sections={docSections}
      searchEnabled={true}
      searchPlaceholder="Search documentation..."
      mobileSidebarOpen={sidebarOpen}
      onMobileSidebarToggle={setSidebarOpen}
    />
  );
};

export default TechnicalDocumentation;

